import React, { useEffect, useState } from "react";
import { QrReader } from 'react-qr-reader';
// import { Link } from 'react-router-dom'
import axios from "axios";
import FiltersModal from "./Filters/Filters";
import Swatch from "../../components/SwatchDetails";
// import FIlterMobileIcon from "../../assets/filter-mobile.png"
import { Pagination, Radio, RadioGroup, FormControlLabel, FormControl, Autocomplete } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
// import Fab from '@mui/material/Fab';
import CloseIcon from '@mui/icons-material/Close';
// import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import { useNavigate } from "react-router-dom";
import { Header } from "./Header";
import countFilters from './utils/filterCount';
import calculateFilterString from './utils/filterString';
import noResultIcon from "../../assets/search-not-found.png"
import { useLocation } from "react-router-dom";
import FilterChips from "./Filters/FilterChips";
import calculateChipData from "./utils/filterChips";
import { getToken } from "../../utils/token";
import AttributeSearchbar from "../../components/AttributesSearch";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert sx={{ fontSize: "1.4rem" }} elevation={6} ref={ref} variant="filled" {...props} />;
});

export const initialState = {
    null___already_shared_with_these_clients: false,
    null___collection_code: true,
    notDispatchOrOutOnLoan: true,
    notnull___shared_with_clientid: false,
    equalto___handed_over_to_client: false,
    equalto___handed_over_to_an_employee_for_internal_use: false,
    equalto___handed_over_to_an_employee_for_showcasing: false,
    Color: [],
    Fabric: [],
    Hand: [],
    Material: [],
    Artwork: [],
    Artist: [],
    Effect: [],
    Techniques: [],
    Era: [],
    UniqueCodes: [],
    Tag: [],
    Status: "",
    cdnullorzero___first_approved_on: "",
    Search: "",
    subquery___amal_sharing___fk_client___fk_card___id: "",
    containsany___location_id: [],
    equalto___handed_over_to_userid: "",
    sharedTillDate: {start: null, end: null},
    returnDate: {start: null, end: null},
    boxNumber: "",
    attributes: [],
    filterType: "all",
    sortBy: "-created_at",
    neverLiked: false,
}

export default function Swatches() {
    const location = useLocation()
    const navigate = useNavigate()
    const searchData = location?.state?.filters ? location?.state?.filters : {};
    const locationChip = location?.state?.locationChip ? [location?.state?.locationChip] : []
    let urlParams = new URLSearchParams(window.location.search);
    const mode = urlParams.get("mode");
    const idEditMode = (mode === "edit");
    const collectionUniqueCodeFromUrl = urlParams.get("coll_uc");
    const TOKEN =getToken()
    if (!TOKEN) {
        navigate("/login")
    }

    const getFiltersFromLocalStorage = () => {
        const savedFilters = localStorage.getItem('filters');
        if (savedFilters){
            return JSON.parse(savedFilters) 
        }
        return []
    }
    // const searchTextFromUrl = urlParams.get("search")
    // const [collectionUniqueCode, setCollectionUniqueCode] = useState("");
    // const [customerUC, setCustomerUC] = useState("");
    // const [username, setUsername] = useState("");
    const [collection, setCollection] = useState([]);
    const [collections, setCollections] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const [filterOpen, setFilterOpen] = useState(false);

    const [Filters, setFilters] = React.useState({...initialState, ...getFiltersFromLocalStorage() , ...searchData})
    const [filterString, setFilterString] = useState(calculateFilterString(Filters));
    const [filterAutofIllData, setFilterAutofIllData] = useState({
        Color: [],
        Fabric: [],
        Hand: [],
        Material: [],
        Artwork: [],
        Artist: [],
        Effect: [],
        Techniques: [],
        Era: [],
        Location: [],
        HandedOverToClients: [],
        SharedWithCliend: [],
        Tag: []
    })
    const [filterCount, setFilterCount] = React.useState({
        Primary: 0,
        Attributes: 0,
        Location: 0,
        More: 0
    })
    const [chipData, setChipData] = useState([...calculateChipData(Filters, filterAutofIllData), ...locationChip])

    const [totalFilterCount, setTotalFilterCount] = useState(0)
    const [selectedSwatches, setSelected] = useState([])
    const [openDialog, setOpenDialog] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [AlertMessage, setAlertMessage] = useState("")
    const [enableSelection, setEnableSelection] = useState(!!collectionUniqueCodeFromUrl);

    const [showSwatchDetails, setShowSwatchDetails] = useState(false)
    const [selectedSwatchUC, setSelectedSwatchUC] = useState("");

    const [scanning, setScanning] = useState(false);
    // const [facingMode, setFacingMode] = useState('environment');
    const [loading, setLoading] = useState(true)

    const deleteAdditionalImageFromState = (uniqueCode, idx) => {
        const swatch = collection.find(itm =>  itm.unique_code===uniqueCode)
        const swatchIndex = collection.findIndex(itm => itm.unique_code===uniqueCode)
        // console.log("Deleting index ", idx, uniqueCode, "from", swatch)
        
        if (swatch?.cdata?.additional_images){
            setCollection(prev => {
                prev[swatchIndex].cdata.additional_images = swatch.cdata.additional_images.filter((img) => img.idx!==idx)
                return [
                    ...prev
                ]
            })
        }
    }

    React.useEffect(() => {
        countFilters(Filters, setFilterCount)
        // eslint-disable-next-line
    }, [Filters])


    const updateState = (updatedFilterState) => {
        // updatedFilterState will be a object of type {filter_key: filter_value}, for EX: {shared_with_client: "true"}
        setFilters(prev=> {
            return {...prev, ...updatedFilterState}
        })
    }
    const handelStateDelete = (item) => {
        const initialFiltersState = Filters;
        let newFilterState;

        if (item.type === "containsany___location_id") {
            newFilterState = {
                ...initialFiltersState,
                [item.type]: initialFiltersState[item.type].filter(id => id !== item.id)
            };
        } else if (item.type === "subquery___amal_sharing___fk_client___fk_card___id" || item.type === "equalto___handed_over_to_userid" || item.type === "boxNumber" || item.type === "Status" || item.type === "Search" || item.type === "cdnullorzero___first_approved_on") {
            newFilterState = {...initialFiltersState, [item.type]: ""};
        } else if (item.type === "sortBy") {
            newFilterState = {...initialFiltersState, [item.type]: "-created_at"};
        } else if(item.type === "null___already_shared_with_these_clients" || item.type === "notnull___shared_with_clientid" || item.type === "equalto___handed_over_to_client" || item.type === "equalto___handed_over_to_an_employee_for_internal_use" || item.type === "null___collection_code" || item.type === "notDispatchOrOutOnLoan" || item.type === "neverLiked"){
            newFilterState = {...initialFiltersState, [item.type]: false};
        } else {
            newFilterState = {...initialFiltersState, [item.type]: initialFiltersState[item.type].filter(i => i !== item.label)};
        }

        setFilters(newFilterState);
        handelSubmit(newFilterState);
    };
    const handelReset = () => {
        setFilters(initialState)
        setFilterString(calculateFilterString(initialState))
        setFilterOpen(false)
        setChipData(calculateChipData(initialState, filterAutofIllData))
        setEnableSelection(false)
        setSelected([])
    }

    const handelSubmit = (FilterData) => {
        let filterString = calculateFilterString(FilterData);
        // const total = countFilters(FilterData, setFilterCount)
        // setTotalFilterCount(total)
        setFilterString(filterString)
        setChipData(calculateChipData(FilterData, filterAutofIllData))
        setFilterOpen(false)
    }

    const handelCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertMessage("")
        setShowAlert(false);
    };

    useEffect(() => {
        let urlParams = new URLSearchParams(window.location.search);
        const searchTextFromUrl = urlParams.get("search");
        if (searchTextFromUrl){
            urlParams.delete("search")
            navigate("/Swatches?" + urlParams.toString(), {replace:  true})
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        let urlParams = new URLSearchParams(window.location.search);
        if (location.state){
            navigate("/Swatches?" + urlParams.toString(), {replace:  true, state: null})
        }
        // eslint-disable-next-line
    }, [])

    const handleChange = (event, value) => {
        setPage(value);
        setLoading(true)
        fecthCollection(value);
    };

    useEffect(() => {
        // console.log(window.location.search)
        // localStorage.setItem("backQueryString",window.location.search);
        setLoading(true)
        const total = countFilters(Filters, setFilterCount)
        setTotalFilterCount(total)
        fecthCollection(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterString]);

    useEffect(() => {
        fetchAutofillData()
        fetchCollections()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [" "]);
  
    useEffect(() => {
      localStorage.setItem('filters', JSON.stringify(Filters));
    }, [Filters]); 

    const fetchCollections = async () => {
        try {
            let response = await axios.get(
                `https://amal.platform.simplifii.com/api/v1/custom/collections`,
                {
                    headers: {
                        Authorization: "Bearer " + TOKEN,
                    },
                }
            );
            setCollections(response.data.response.data || []);
        } catch (e) {
            if (e && e["message"]) {
                alert(e["message"]);
            }
        }
    } 

    const fetchAutofillData = async () => {

        const keys = ["Color", "Fabric", "Hand", "Material", "Artwork", "Artist", "Effect", "Techniques", "Era", "Location", "Tag"]
        const requests = keys.map((key) => axios.get(
            `https://amal.platform.simplifii.com/api/v1/custom/mastertags?valid=1&type=${key}`,
            {
                headers: {
                    Authorization: "Bearer " + TOKEN,
                },
            }
        ).catch((error) => console.log("API ERROR", error)));
        const otherRequest = [
            axios.get('https://amal.platform.simplifii.com/api/v1/cards?type=Customer', {
                headers: {
                    Authorization: "Bearer " + TOKEN,
                },
            }),
            axios.get('https://amal.platform.simplifii.com/api/v1/cards?type=Employee,Customer', {
                headers: {
                    Authorization: "Bearer " + TOKEN,
                },
            })
        ]
        try {
            let responseArray = await axios.all(requests)
            let otherResponseArray = await axios.all(otherRequest)
            responseArray.forEach((res, index) => {
                setFilterAutofIllData(prev => {
                    return { ...prev, [keys[index]]: res.data.response.data }
                })
            })
            setFilterAutofIllData(prev => {
                return { ...prev, "SharedWithCliend": otherResponseArray[0].data.response.data }
            })
            setFilterAutofIllData(prev => {
                return { ...prev, "HandedOverToClients": otherResponseArray[1].data.response.data }
            })
            setFilterAutofIllData(prev => {
                setChipData(calculateChipData(Filters, prev))
                return {...prev}
            })

        } catch (e) {
            if (e && e["message"]) {
                alert(e["message"]);
            }
        }
    }

    const fecthCollection = async (page) => {
        // setCollectionUniqueCode(urlParams.get("coll_uc"))
        // setCustomerUC(urlParams.get("cuc"))
        // setUsername(urlParams.get("un"))
        // console.log(collectionUniqueCode, customerUC, username);
        try {
            let response = await axios.get(
                `https://amal.platform.simplifii.com/api/v1/cards?type=Swatch&doesnotmatchwithany___state=Temp,Deleted,Claimed,Free,On%20Frame&cdnullorzero___per_day_rent=1&items_per_page=50&page=${page}${filterString !== "" ? filterString : ""}`,
                {
                    headers: {
                        Authorization: "Bearer " + TOKEN,
                    },
                }
            );
            // console.log(response)
            // setDescription(response.data.collection_description);
            setLoading(false)
            setCollection(response.data.response.data || []);
            setTotal(response.data.response.pagination.total)
            // localStorage.setItem('collection',JSON.stringify(response.data.response.data||[]));

        } catch (e) {
            setLoading(false)
            if (e && e["message"]) {
                alert(e["message"]);
            }
        }
    };

    const toggleSelected = (selected, uc) => {
        if (selected) {
            setSelected(item => item.filter(unique_code => unique_code !== uc))
        }
        else {
            setSelected(prev => [...prev, uc])
        }
    }

    const handelAddToCollection = async (description) => {
        try {
            let response = await axios.patch(
                `https://amal.platform.simplifii.com/api/v1/custom/addSwatchesToCollection`,
                {
                    card_unique_code: selectedSwatches,
                    collection_desc: description,
                },
                {
                    headers: {
                        Authorization: "Bearer " + TOKEN,
                    }
                }
            );
            setAlertMessage(response.data.msg)
            setSelected([])
            setShowAlert(true)

        } catch (e) {
            if (e && e["message"]) {
                alert(e["message"]);
            }
        }

        setOpenDialog(false)
    }

    const handleAddToExistingCollection = async (collection_unique_code) => {
        try {
            let response = await axios.patch(
                `https://amal.platform.simplifii.com/api/v1/custom/addSwatchesToCollection`,
                {
                    card_unique_code: selectedSwatches,
                    collection_unique_code: collection_unique_code,
                    swatch_unique_code: selectedSwatches
                },
                {
                    headers: {
                        Authorization: "Bearer " + TOKEN,
                    }
                }
            );
            setAlertMessage(response.data.msg)
            setSelected([])
            setShowAlert(true)

        } catch (e) {
            if (e && e["message"]) {
                alert(e["message"]);
            }
        }

        setOpenDialog(false)
    }

    const handelClickSwatch = (uc) => {
        const selected = selectedSwatches.includes(uc)
        if (enableSelection) {
            toggleSelected(selected, uc)
        } else {
            // navigate("/swatch/" + uc)
            // window.open("/swatch/" + uc, '_blank', 'noopener,noreferrer');
            setShowSwatchDetails(true)
            setSelectedSwatchUC(uc)
        }
    }
    
    useEffect(() => {
        if (showSwatchDetails){
            document.title = selectedSwatchUC
        } else{
            document.title = "Ethically run luxury hand-embroidery atelier"
        }
        
    }, [selectedSwatchUC, showSwatchDetails])
    const handleScan = (result) => {
        if (result && result !== "") {
            const uniqueCode = result.text
            const filterState = {...initialState, "Search": uniqueCode }
            updateState(filterState)
            handelSubmit(filterState)
            if (showSwatchDetails){
                setShowSwatchDetails(false)
            }
            handleClose()
        }
    }

    // const handleScan = (result) => {
    //     if (result && result !== "") {
    //         const uniqueCode = result.text;
    //         setEnableSelection(true)

    //         const uniqueCodeArray = Filters.UniqueCodes;
    //         if (!uniqueCodeArray.includes(uniqueCode)){
    //             uniqueCodeArray.push(uniqueCode)
    //             setSelected(prev => [...prev, uniqueCode])
    //         }
    //         const filterState = {...initialState, null___shared_with_clientid: false, "UniqueCodes": uniqueCodeArray, "Status": "" }
            
    //         updateState(filterState)
    //         handelSubmit(filterState)
    //         if (showSwatchDetails){
    //             setShowSwatchDetails(false)
    //         }
    //         handleClose()
    //     }
    // }

    // const handleSwitchCamera = () => {
    //     setFacingMode(facingMode === 'environment' ? 'user' : 'environment');
    // };

    const handleClose = () => {
        setScanning(false);
    };

    if (!scanning) {
        return (
            <div>
            {!(idEditMode && showSwatchDetails) &&<Header token={TOKEN} handelReset={handelReset} onSubmit={() => handelSubmit(Filters)} search={Filters.Search} updateState={updateState} showSwatchDetails={showSwatchDetails} setFilterOpen={setFilterOpen} totalFilterCount={totalFilterCount} setEnableSelection={setEnableSelection} enableSelection={enableSelection} setScanning={setScanning} />}                
            {showSwatchDetails ?
                    <Swatch   updateAttribute={(value) => {
                        const filterState = {...initialState,  Status: "",attributes: value}
                        setFilters(filterState)
                        handelSubmit(filterState)
                    }} refetch={() => fecthCollection(page)} filterAutofIllData={filterAutofIllData} isEditMode={idEditMode} deleteAdditionalImageFromState={deleteAdditionalImageFromState} setShowSwatchDetails={setShowSwatchDetails} uniqueCode={selectedSwatchUC} setSelectedSwatchUC={setSelectedSwatchUC} collection={collection} /> :
                   <div> 
                    <div className="chips-container search-bar-wrapper">
                        <AttributeSearchbar
                            onSubmit={() => handelSubmit(Filters)}
                            fullwidth={true}
                            search={Filters.attributes}
                            setSearch={(value) => updateState({ attributes: value })}
                            filterType={Filters.filterType}
                            setFilterType={(value) => updateState({ filterType: value })}
                        />
                    </div>
                      <FilterChips handelStateDelete={handelStateDelete} chipData={chipData}/>
                      <div className='collection-container'>
                        {/* <Fab sx={{ position: "fixed", "bottom": 20, "right": 20, display: { sm: "none" } }} aria-label="add">
                            <div onClick={() => setFilterOpen(true)}>
                                <div className="filter-total-count">{totalFilterCount}</div>
                                <img alt="Filter icon mobile" src={FIlterMobileIcon} />
                            </div>
                        </Fab> */}
                        {enableSelection && <div className='add-collection-container'>
                            <div>
                                <p>Click/tap on the swatches to select them for adding to a collection.</p>
                                <p> If you wish to cancel this action, you can click on [+] icon on top right again.</p>
                            </div>
                            {(selectedSwatches.length > 0) && <div className="header-button" >
                                <p>{selectedSwatches.length} {selectedSwatches.length === 1 ? "Item" : "Items"} Selected</p>
                                <button onClick={() => setOpenDialog(true)} > Add to Collection </button>
                            </div>}
                        </div>}

                        {
                            collection.length === 0 ? (
                                <div className="no-seach-found-container">
                                    {!loading
                                        ? <><div className="no-seach-found">
                                            <img src={noResultIcon} alt="No search result found Icon" />
                                        </div>
                                            <div className="no-search-found-text">
                                                <h3>No Result Found </h3>
                                                <p>Try a different search</p>
                                            </div></>
                                        : <div className="loading-container"></div>
                                    }
                                </div>
                            )
                            :
                        <>
                            <section className="gallery">
                                <div>
                                    {collection.map((image, index) => <SwatchesCard aspectRatio = { image.cdata.primary_image_width / image.cdata.primary_image_height } handelClickSwatch={() => handelClickSwatch(image.unique_code)} setSelectedSwatchUC={setSelectedSwatchUC} enableSelection={enableSelection} selected={selectedSwatches.includes(image.unique_code)} key={image.id} image_url={image.cdata.primary_image_thumbnail} uq={image.unique_code} />)}
                                </div>
                            </section>
                            <div style={{ justifyContent: 'center', display: 'flex' }}>
                                <Pagination count={Math.ceil(total / 50)} page={page} shape={'rounded'} onChange={handleChange} showFirstButton showLastButton />
                            </div>
                        </>
                        }

                        {/* Modal for adding collection */}
                        <FormDialog collections={collections} handleAddToExistingCollection={handleAddToExistingCollection} handelAddToCollection={handelAddToCollection} open={openDialog} setOpen={setOpenDialog} collectionUniqueCodeFromUrl={collectionUniqueCodeFromUrl} />

                        {/*Filter Modal*/}
                        <FiltersModal handelSubmit={handelSubmit} count={filterCount} Filters={Filters} updateState={updateState} handelReset={handelReset} autofillData={filterAutofIllData} open={filterOpen} setOpen={setFilterOpen} />

                        {/* COLLECTION ADDING SUCCESSFULL ALERT COMPONENT */}
                       <SuccessAlert  showAlert={showAlert} handelCloseAlert={handelCloseAlert} AlertMessage={AlertMessage}  />
                      </div>
                    </div>
                }
            </div>
        )
    } else {
        return (
            <div>
                {/* <QrScanner
                    className="scanner"
                    facingMode={facingMode}
                    onScan={handleScan}
                    onError={handleError}
                    legacyMode={true}
                /> */}
                 <QrReader
                    className="scanner"
                    constraints={{ facingMode: "environment" }}
                    onResult={handleScan}
                    style={{ width: '100%' }}
                 />
                <button className="close-btn" onClick={handleClose}>
                    <CloseIcon />
                </button>

                {/* <button className="switch-btn" onClick={handleSwitchCamera}>
                    <CameraswitchIcon />
                </button> */}
            </div>
        )
    }

function SuccessAlert({ showAlert, handelCloseAlert, AlertMessage }) {
        return (
        <Snackbar open={showAlert} autoHideDuration={6000} onClose={handelCloseAlert}>
            <Alert onClose={handelCloseAlert} severity="success" sx={{
                width: '100%'
            }}>
                {AlertMessage}
            </Alert>
        </Snackbar>);
    }
}

function FormDialog({ open, setOpen, handelAddToCollection, handleAddToExistingCollection, collections, collectionUniqueCodeFromUrl }) {
    const [desc, setDesc] = useState("")
    const [Error, setError] = useState(false)
    const [collection, setCollection] = useState(null)
    const [addTo, setAddTo] = useState("new")

    useEffect(() => {
        if (collectionUniqueCodeFromUrl && collections.length > 0) {
            setAddTo("existing");
            const preSelectedCollection = collections.find(
                (col) => col.unique_code === collectionUniqueCodeFromUrl
            );
            console.log({preSelectedCollection})
            if (preSelectedCollection) {
                setCollection(preSelectedCollection.unique_code);
            }
        }
    }, [collectionUniqueCodeFromUrl, collections]);
    const handleClose = () => {
        setOpen(false);
    };

    const handelChange = (e) => {
        setDesc(e.target.value)
        setError(false)
    }
    function handelSubmit() {
        if (addTo === "new") {
            if (desc === "") {
                setError(true)
                return
            }
            handelAddToCollection(desc)
        } else {
            if (!collection) {
                setError(true)
                return
            }
            handleAddToExistingCollection(collection)
        }
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle sx={{ fontSize: "1.5rem", textAlign: "center", pb: 0.75 }}>Add to a collection</DialogTitle>
                <DialogContent sx={{ p: 4, height: "130px"}}>
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={addTo}
                            onChange={(e) => setAddTo(e.target.value)}
                        >
                            <FormControlLabel value="new" control={<Radio />} label="New Collection" />
                            <FormControlLabel value="existing" control={<Radio />} label="Existing Collection" />
                        </RadioGroup>
                    </FormControl>
                    {addTo === "new" ?
                        <TextField
                            sx={{
                                minWidth: {
                                    sm: "100%",
                                    md: 450
                                }, pb: 0
                            }}
                            autoFocus
                            size="small"
                            required
                            margin="dense"
                            id="name"
                            label="Collection Description"
                            fullWidth
                            error={Error}
                            value={desc}
                            onChange={handelChange}
                            variant="outlined"

                        /> :
                        <Autocomplete
                            id="combo-box-demo"
                            options={collections}
                            fullWidth
                            get
                            getOptionLabel={(option) => option.description}
                            sx={{
                                minWidth: {
                                    sm: "100%",
                                    md: 550
                                }, pb: 0
                            }}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option.unique_code}>
                                        {option.description}
                                    </li>
                                );
                            }}
                            onChange={(e, value) => setCollection(value ? value.unique_code : null)}
                            value={collections.find(option => option.unique_code === collection) || null}
                            renderInput={(params) => <TextField {...params} label="Collections" />}
                        />}
                </DialogContent>
                <DialogActions>
                    <Button sx={{ color: "#15163a" }} onClick={handleClose}>Cancel</Button>
                    <Button onClick={handelSubmit} sx={{ color: "#15163a" }}>Submit</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

function SwatchesCard({ image_url, selected, enableSelection, handelClickSwatch, uq, aspectRatio }) {
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    return (
        <div className='swatch-card-wrapper2'>
            <div style={{ aspectRatio: aspectRatio || undefined}} onClick={handelClickSwatch} className={`swatch-card-container2 ${(selected && enableSelection) ? "selected-image" : ""}`}>
                <img alt="Swatch" src={image_url} />
                {(selected && enableSelection) && <div className="checkbox-container">
                    <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }} {...label}
                        icon={<RadioButtonUncheckedIcon />}
                        checkedIcon={<CheckCircleIcon />}
                        checked={true}
                        disabled
                    />
                </div>}
                <div className="open-in-new-container " onClick={(e) => {
                    e.stopPropagation()
                    window.open("/swatch/" + uq + window.location.search, '_blank', 'noopener,noreferrer')}}>
                    <OpenInNewIcon sx={{ color: "#606060",  }} />
                </div>
            </div>
        </div>
    )
}
